






import {Component, Vue} from 'vue-property-decorator';
import {CodeResp} from '@/oauth/AuthTokenDto';

@Component({
  components: {},
})
export default class CodeSlider extends Vue {
  codeResp: CodeResp = new CodeResp();
  private ncToken = ['FFFF0N0000000000A574', (new Date()).getTime(), Math.random()].join(':');

  private initCode() {
    const ncToken = this.ncToken;
    // eslint-disable-next-line no-undef,@typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const noCaptcha: any = window.NoCaptcha;
    const nc = noCaptcha.init({
      renderTo: '#nc',
      appkey: 'FFFF0N0000000000A574',
      scene: 'nc_register_h5',
      token: ncToken,
      trans: {'key1': 'code200'},
      elementID: ['usernameID'],
      // eslint-disable-next-line @typescript-eslint/camelcase
      is_Opt: 0,
      language: 'cn',
      timeout: 10000,
      retryTimes: 5,
      errorTimes: 5,
      inline: false,
      apimap: {
        // 'analyze': '//a.com/nocaptcha/analyze.jsonp',
        // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
      },
      bannerHidden: false,
      initHidden: false,
      callback: (data: { csessionid: string; sig: string }) => {
        window.console && console.log(ncToken);
        window.console && console.log(data);

        this.codeResp.sessionId = data.csessionid;
        this.codeResp.sig = data.sig;
        this.codeResp.token = ncToken;
        this.$emit('input', this.codeResp);
      },
      error: function (s: string) {
        nc.reset();
        console.error(s);
      },
    });
    noCaptcha.setEnabled(true);
    nc.reset();//请务必确保这里调用一次reset()方法

    noCaptcha.upLang('cn', {
      'LOADING': '加载中...',//加载
      'SLIDER_LABEL': '请向右滑动验证',//等待滑动
      'CHECK_Y': '验证通过',//通过
      'ERROR_TITLE': '非常抱歉，这出错了...',//拦截
      'CHECK_N': '验证未通过', //准备唤醒二次验证
      'OVERLAY_INFORM': '经检测你当前操作环境存在风险，请输入验证码',//二次验证
      'TIPS_TITLE': '验证码错误，请重新输入',//验证码输错时的提示
    });
  }

  private mounted() {
    this.initCode();
    return;
  }
}
